import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdsService {

  baseUrl = `${environment.apis.base}/publi`;

  constructor(private readonly http: HttpClient) { }

  datatable(page?: number): Observable<Object> {
    let url = this.baseUrl;

    if (typeof page === 'number') {
      url += `?page=${page}`;
    }
    return this.http.get<any>(url);
  }

  show(id: number): Observable<Object> {
    const url = `${this.baseUrl}/${id}`;

    return this.http.get<any>(url);
  }

  createOrUpdate(data: RxFormGroup, id?: number): Observable<Object> {
    let url = this.baseUrl;

    if (id) {
      url += `/${id}`;
    }

    return this.http.post<any>(url, data.toFormData());
  }

  delete(id: number): Observable<Object> {
    const url = `${this.baseUrl}/${id}`;

    return this.http.delete<any>(url);
  }
}
